import React, { createContext, useState } from 'react';
import { IntlProvider, createIntl, createIntlCache } from 'react-intl';

// locales
import messages_fr from '../../locales/fr.json';
import messages_en from '../../locales/en.json';
import messages_de from '../../locales/de.json';

const messagesInit = {
  fr: messages_fr,
  en: messages_en,
  de: messages_de,
};

// utils
import { flattenMessages } from '@/utils/i18n';

export const IntlProviderContext = createContext(undefined);

const IntlProviderWrapper = ({ locale, children }) => {
  const localeBrowser = (process.browser && window.navigator.language) || 'fr';

  const messagesFlatten = flattenMessages(messagesInit[locale]);
  const [messages, setMessages] = useState(messagesFlatten);
  const cache = createIntlCache();
  const intl = createIntl({ locale, messages }, cache);
  if (typeof window !== 'undefined') {
    window.i18nFinary = intl;
  }

  const switchLang = (lang) => {
    setMessages(flattenMessages(messagesInit[lang]));
  };

  return (
    <IntlProviderContext.Provider
      value={{
        switchLang,
      }}
    >
      <IntlProvider
        key={locale}
        locale={locale}
        messages={intl.messages}
        defaultLocale={localeBrowser}
      >
        {children}
      </IntlProvider>
    </IntlProviderContext.Provider>
  );
};

export { IntlProviderWrapper, IntlProviderContext as IntlContext };
